import { pushDataToGtm } from "../tracking";

const USE_PIWIK_TRACKING = true;

/**
 * Handles GTM tracking by pushing data to the data layer object.
 *
 * @param dataLayerObject - The data layer object containing ecommerce data in new types provided by Piwik.
 */
export const handleGtmTracking = (
    dataLayerObject: object
) => {
    if (!USE_PIWIK_TRACKING || !dataLayerObject) return;

    pushDataToGtm({ ecommerce: null });
    pushDataToGtm(dataLayerObject);
};